import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { catchError, Observable, throwError } from 'rxjs';
import { RestService } from '../services/rest/rest.service';

@Injectable({ providedIn: 'root' })
export class RestResolver<T>  {
  constructor(private restService: RestService, private router: Router) {}
  private previousUrl: string | null = null;

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<T> {
    let dataUri = route.data['uri'];
    let deslug = (route.data['deslug'] as boolean) || false;

    for (let paramKey in route.params) {
      let value = route.params[paramKey];
      if (deslug && value) {
        const splits = value.split('-');
        if (splits.length > 0) {
          value = splits[0];
        }
      }

      dataUri = dataUri.replace(':' + paramKey, value);
    }

    return this.restService.getList(dataUri).pipe(
      catchError(error => {
        this.router.navigateByUrl('/404');
        return throwError(error);
      })
    );
  }
}
